import { FormAssembly } from "@jmc/core/src/components/FormAssembly/FormAssembly";
import { getCaseInsensitiveKey } from "@jmc/utils/utils/getCaseInsensitiveKey";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    title: string;
    formAssemblyRestUrl: string;
    compliance?: boolean;
}

export const FormAssemblyBlock = (props: Props): JSX.Element => {
    const { title, formAssemblyRestUrl, compliance = false } = props;
    const { t } = useTranslation();

    const searchParams =
        typeof window !== `undefined` && Object.fromEntries(new URLSearchParams(window?.location?.search));

    const webid = getCaseInsensitiveKey("webid", searchParams);
    const codsid = getCaseInsensitiveKey("codsId", searchParams);

    const params = { ...searchParams, webid, codsid };

    return (
        <FormAssembly
            formAssemblyRestUrl={formAssemblyRestUrl}
            compliance={compliance}
            complianceText={t("Please update your compliance settings to see the form", { ns: "common" })}
            params={params}
            title={title}
        />
    );
};

export default FormAssemblyBlock;
